import { LayerTypeDTO } from 'business/models/Models';
import React, { useContext } from 'react';
import { ISOValuesTableView } from './ISOValuesTableView';
import { OptimizationContext } from './OptimizationContext';
import { OptimizationLocation } from './OptimizationLocation';

type ConfigureOptimizationProps = {
  totalNumOfWells: number;
};

export const ConfigureOptimization = ({
  totalNumOfWells,
}: ConfigureOptimizationProps) => {
  const context = useContext(OptimizationContext);
  return context.layerType == LayerTypeDTO.Screen ? (
    <ISOValuesTableView />
  ) : (
    <OptimizationLocation totalNumOfWells={totalNumOfWells} />
  );
};
